module.exports = __webpack_public_path__ + "static/media/WATCH@3x.4a9c6149.png";